export const usersQueryKeys = {
  all: ['users'],
  details: () => [...usersQueryKeys.all, 'detail'],
  detail: (id) => [...usersQueryKeys.details(), id],
  pagination: (page) => [...usersQueryKeys.all, 'pagination', page],
  infinite: () => [...usersQueryKeys.all, 'infinite'],
};
export const userPreferencesQueryKeys = {
  all: ['userPreferences'],
  details: () => [...userPreferencesQueryKeys.all, 'detail'],
  detail: () => [...userPreferencesQueryKeys.details(), 'single'], // or add ID if needed
  pagination: (page) => [...userPreferencesQueryKeys.all, 'pagination', page],
  infinite: () => [...userPreferencesQueryKeys.all, 'infinite'],
};